import { Trans, useTranslation } from 'react-i18next';

import { TERMS_AND_CONDITIONS_URL } from '../constants';

import { ExternalLegalLink } from './ExternalLegalLink';
import { LegalArticle } from './LegalArticle';

export function TermsContent() {
  const { t } = useTranslation('legal');

  return (
    <LegalArticle title={t(($) => $.terms.title)}>
      <p className="text-sm leading-relaxed break-words text-gray-600">
        <Trans
          components={{
            websiteLink: <ExternalLegalLink href={TERMS_AND_CONDITIONS_URL} />,
          }}
          i18nKey={($) => $.terms.body}
          ns="legal"
        />
      </p>
    </LegalArticle>
  );
}
